export default __webpack_public_path__ + "static/media/1.ce4cb045.svg";